import { AddressDetailsModel } from '../client/client.model';

export class CompanyDetailsModel {
  backgroundColor: string;
  buttonColor: string;
  name: string;
  companyLogoUrl: string;
  showLogoForCustomer: boolean;
  showReferralInvitation: boolean;
  address: AddressDetailsModel;
}
